import { AFilter, SingleEntityTextFilter } from './Filter';
import { filter } from '@amcharts/amcharts4/.internal/core/utils/Iterator';


export interface IFetchResponse {
    success(data: object): void;
    error(error: object): void;
}

export interface IFetchable {
    fetchData(responseCB: IFetchResponse, params: ARequestVM): void;
}

export abstract class ApiWrapper implements IFetchable {
    protected apiString: string;
    constructor(apiString: string) {
        this.apiString = apiString;
    }

    abstract fetchData(responseCB: IFetchResponse, params: ARequestVM): void;

}


export class ARequestVM {
    private filters: AFilter[];
    public startDate: any;
    public endDate: any;
    public offsetMin: number=0;
    public Route: string;
    constructor() {
        this.filters = new Array();
        this.Route = "";
    }

    protected addFilter(filter: AFilter) {
        this.filters.push(filter);
    }
    addSingleEntityFilter(searchString: string) {
        this.filters.push(new SingleEntityTextFilter(searchString) )
    }

}


export interface IParsable {
    parseJson(jsonToParse: any): void;
}

export class FetchApi extends ApiWrapper {

    private postData: boolean;

    constructor(api: string, post: boolean = true) {
        super(api);

        this.postData = post;
    }

    fetchData(responseCB: IFetchResponse, params: ARequestVM): void {
        let paramsString: string = JSON.stringify(params);

        if (this.postData) {
            //Post:
            fetch(this.apiString, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: paramsString
            }).then(res => res.json())
                .then(json => responseCB.success(json))
                .catch(err => responseCB.error(err));
        }
        else {
            //Get:

            fetch(this.apiString).then(response => response.json())
                .then(json => {
                    responseCB.success(json);
                }).catch(err => {
                    responseCB.error(err);
                });
        }
    }

}

export class NoApiWrapper  extends ApiWrapper {
    fetchData(responseCB: IFetchResponse, params: ARequestVM): void {
        throw new Error("Method not implemented.");
    }

}

export class PollingApi extends ApiWrapper {

    private timeout: number;
    private pollingVar: any;
    private postData: boolean;

    constructor(api: string, timeout: number, postData: boolean = true) {
        super(api);
        this.timeout = timeout;
        this.postData = postData;
    }

    private pollData(responseCB: IFetchResponse, params: ARequestVM) {
        let paramsString: string = JSON.stringify(params);

        if (this.postData) {
            //Post:
            fetch(this.apiString, {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: paramsString
            }).then(res => res.json())
                .then(json => responseCB.success(json))
                .catch(err => responseCB.error(err));
        }
        else {
            //Get:

            fetch(this.apiString).then(response => response.json())
                .then(json => {
                    responseCB.success(json);
                }).catch(err => {
                    responseCB.error(err);
                });
        }


    }

    fetchData(responseCB: IFetchResponse, params: ARequestVM) {
        this.pollData(responseCB, params);
        this.pollingVar = setInterval(() => {
            this.pollData(responseCB, params);
        }, this.timeout)
    }
}

export class PushApi extends ApiWrapper {
    constructor(api: string) {
        super(api);
    }

    fetchData(responseCB: IFetchResponse, params: ARequestVM) {
        var ws = new WebSocket(this.apiString);

        ws.onopen = function () {

            // Web Socket is connected, send data using send()
            ws.send(JSON.stringify(params));
            console.log("WebSocket opened");
        };

        ws.onmessage = function (evt) {
            //console.log(received_msg);
            try {
                let dataJson = JSON.parse(evt.data)
                responseCB.success(dataJson);
            } catch (Error: any) {
                responseCB.error(Error);
            }
        };

        ws.onclose = function () {

            // websocket is closed
            console.log("Connection is closed...");
        };
    }
}
